import { FieldError, FieldErrors, FieldValues } from "react-hook-form";
import { Alert, Badge, Text, useMantineTheme } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

// TODO: Field errors

export default function FormStateError({
  errors,
  sourceField,
}: {
  errors: FieldErrors;
  sourceField?: string;
}) {
  if (errors) {
    return (
      <div>
        {Object.keys(errors).map((field) => {
          return (
            <FieldErrorMessages
              error={errors[field]}
              field={Array.isArray(errors) ? `Row ${Number(field) + 1}` : field}
              key={field}
              sourceField={sourceField}
            />
          );
        })}
      </div>
    );
  }

  return <></>;
}

function FieldErrorMessages({
  field,
  error,
  sourceField,
}: {
  field: string;
  error: FieldError | FieldErrors | undefined;
  sourceField?: string;
}) {
  const theme = useMantineTheme();

  if (error) {
    if (error.message) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: theme.spacing.xs,
          }}
          data-testid="error"
        >
          {/*           <Alert
            variant="light"
            miw={400}
            icon={<IconAlertCircle size={16} />}
            title={`Error - [ ${sourceField ? `${sourceField} / ${field}` : field} ]`}
            color="pink"
          >
            {`${error.message ? error.message : error.type}`}
          </Alert> */}
          <Badge mr="xs" radius="xs" color={"red"} variant="light">
            Error
          </Badge>
          <Text
            fs="italic"
            size="sm"
          >{`[ ${sourceField ? `${sourceField} / ${field}` : field} ] - ${error.message ? error.message : error.type}`}</Text>
        </div>
      );
    } else {
      return (
        <FormStateError
          errors={error as FieldErrors}
          sourceField={sourceField ? `${sourceField} / ${field}` : field}
        />
      );
    }
  } else {
    return <></>;
  }
}
